import Vue from 'vue'

Vue.filter('currency', value => new Intl.NumberFormat(
  'pt-BR',
  {
    style: 'currency',
    currency: 'BRL',
  },
).format(value))
